import React from 'react'

import { Form, Col } from '_zari/core'

import { MonedasConstant } from 'constants/index'

const ImportePagoFormGroup = ({
  vMoneda,
  vMonedaPago,
  vTipoCambio,
  vImporteBase,
  iValue,
  setFieldValue
}) => {
  React.useEffect(() => {
    if (vMoneda && vMonedaPago) {
      if (vMoneda !== vMonedaPago) {
        if (vMoneda === MonedasConstant.SOLES && vMonedaPago === MonedasConstant.DOLARES) {
          const nuevoMonto = +(parseFloat(vImporteBase) / parseFloat(vTipoCambio)).toFixed(2)
          setFieldValue('importePago', nuevoMonto)
        } else if (vMoneda === MonedasConstant.DOLARES && vMonedaPago === MonedasConstant.SOLES) {
          const nuevoMonto = +(parseFloat(vImporteBase) * parseFloat(vTipoCambio)).toFixed(2)
          setFieldValue('importePago', nuevoMonto)
        }
      } else {
        setFieldValue('importePago', vImporteBase)
      }
    } else {
      setFieldValue('importePago', vImporteBase)
    }
  }, [vMoneda, vMonedaPago, vTipoCambio, vImporteBase, setFieldValue])

  return (
    <Form.Group>
      <Form.Label
        text={`IMPORTE (${MonedasConstant.__dictionary[vMonedaPago].signo})`}
        htmlFor='number-importePago'
        md={4}
        alignRightAt='md'
      />
      <Col md={8}>
        <Form.InputNumber id='number-importePago' disabled value={iValue} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImportePagoFormGroup)
